import React from 'react';

interface SwitchProps {
  label: string;
  isOn: boolean;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

const Switch = ({ label, isOn, onChange }: SwitchProps) => {
  return (
    <label className="flex items-center cursor-pointer">
      <div className="relative">
        <input
          type="checkbox"
          className="sr-only" // Visually hide the checkbox but keep it accessible
          checked={isOn}
          onChange={onChange}
        />
        {/* Track */}
        <div
          className={`block w-14 h-8 rounded-full ${
            isOn ? 'bg-blue-600' : 'bg-gray-300'
          }`}></div>
        {/* Thumb */}
        <div
          className={`dot absolute left-1 top-1 bg-white w-6 h-6 rounded-full transition transform ${
            isOn ? 'translate-x-6' : 'translate-x-0'
          }`}></div>
      </div>
      <span className="ml-3 text-base text-gray-700 font-semibold">{label}</span>
    </label>
  );
};

export default Switch;
